module.exports = __webpack_public_path__ + "static/img/znbm.a7f26f3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/daping/znbm.png
// module id = DuVH
// module chunks = 0